import { theme } from 'shared/styles/theme';
import { Box } from 'shared/ui/Box';
import { Paper } from 'shared/ui/Paper';
import { Typography } from 'shared/ui/Typography';

import styled from '@emotion/styled';

export const EmptyBoxStyled = styled(Box)({
  width: '100%',
  padding: theme.space[4],
  borderRadius: theme.space[4],
  position: 'absolute',
  background: `${theme.colors.purewhite}`,
  border: '2px solid black',
  marginTop: '-2px',
  overflow: 'hidden',
  zIndex: '1',
});

export const SearchBlockStyled = styled(Paper)`
  width: 100%;
  max-height: 500px;
  border-radius: ${theme.space[4]};
  position: absolute;
  background: ${theme.colors.purewhite};
  border: 2px solid black;
  overflow: hidden;
  margin-top: -2px;
  z-index: 1;

  &:empty {
    border: none !important;
  }
`;

export const SearchResultStyled = styled(Box)({
  width: 'calc(100% + 2px)',
  maxHeight: '500px',
  background: `${theme.colors.purewhite}`,
  overflowX: 'auto',
  marginTop: '-2px',
});

export const SearchItemStyled = styled(Box)({
  width: '100%',
  display: 'flex',
  borderBottom: '2px solid black',
  padding: `${theme.space[4]}`,
  cursor: 'pointer',
  '&:hover': {
    background: theme.colors.yellow100,
  },
  ':last-child': {
    borderBottom: 0,
  },
});

export const UserNameStyled = styled(Typography)<{
  mb?: string;
  active?: boolean;
}>`
  display: flex;
  flex-direction: column;
  font-weight: ${theme.fontWeights.bold};
  font-size: ${theme.fontSizes[17]};
  margin-bottom: ${({ mb }) => (mb ? mb : `${theme.space[2]}`)};
  color: ${({ active }) => (active ? 'black' : `${theme.colors.gray}`)};
`;

export const UserInfoStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: theme.space[4],
  gap: theme.space[2],
});
